import { FormBuilder } from '../../modules/formBuilder'
import { LoadingScreen } from '../../modules/loadingScreen'
import Otp from '../../modules/otp'
import { ProductSelection } from '../../modules/productSelection'
import Review from '../../modules/review'
import { StatusScreen } from '../../modules/statusScreen'

export const lntStateMap = {
  CC_START: {
    Component: LoadingScreen,
  },
  LNT_PERSONAL_DETAILS: {
    Component: FormBuilder,
  },
  LNT_OTHER_DETAILS: {
    Component: FormBuilder,
  },
  LNT_REVIEW_DETAILS: {
    Component: Review,
  },
  OTP_GENERATED: {
    Component: Otp,
  },
  DEDUPE_REJECTED: {
    Component: StatusScreen,
  },
  PREAPPROVED_REJECTED: {
    Component: StatusScreen,
  },
  LNT_IPA_REJECTED: {
    Component: StatusScreen,
  },
  OTP_BLOCKED: {
    Component: StatusScreen,
  },
  LNT_INCORRECT_DETAILS: {
    Component: StatusScreen,
  },
  LNT_IPA_PENDING: {
    Component: LoadingScreen,
    props: {
      title: 'Please Wait!\nChecking Your Eligibility',
      description:
        'Please wait while we are checking your\n eligibility with L&T Finance',
      timer: {
        enabled: true,
        durationInSec: 150,
      },
      refresh: {
        enabled: true,
        refreshIntervalInSec: 15,
      },
      statusScreenProps: {
        status: {
          statusTitle: 'Still Processing...',
          title: 'Still Processing...',
          subTitle:
            "We're still waiting on the final confirmation from L&T Finance. We will notify you as soon as we have a response.",
          description:
            "We're still waiting on the final confirmation from L&T Finance. We will notify you as soon as we have a response.",
          image: 'CLOCK_ARROW_BLUE',
        },
        note: {
          position: 'top',
          icon: 'ClockOutlined',
          text: 'This may take up to 2 hours. You will be notified once updated status is received from L&T Finance.',
          type: 'error',
        },
      },
    },
  },
  LNT_SUBMIT_CUSTOMER_DETAILS: {
    Component: LoadingScreen,
    props: {
      title: 'Please Wait!\nSubmitting your Details',
      description:
        'Please wait while we are submitting your\n details to L&T Finance',
      timer: {
        enabled: true,
        durationInSec: 30,
      },
      refresh: {
        enabled: true,
        refreshIntervalInSec: 5,
      },
      statusScreenProps: {
        status: {
          statusTitle: 'Still Processing...',
          title: 'Still Processing...',
          subTitle:
            "We're still waiting on the final confirmation from L&T Finance. We will notify you as soon as we have a response.",
          description:
            "We're still waiting on the final confirmation from L&T Finance. We will notify you as soon as we have a response.",
          image: 'CLOCK_ARROW_BLUE',
        },
        note: {
          position: 'top',
          icon: 'ClockOutlined',
          text: 'This may take up to 48 hours. You will be notified once updated status is received from L&T Finance.',
          type: 'error',
        },
      },
    },
  },
  LNT_IPA_APPROVED: {
    Component: ProductSelection,
    props: {
      backgroundGradientColors: ['#8D8D8D', '#000000'],
    },
  },
  SERVER_ERROR: {
    Component: StatusScreen,
  },
}
